import { render, staticRenderFns } from "./FilmListItem.vue?vue&type=template&id=06d92eb3&scoped=true&"
import script from "./FilmListItem.vue?vue&type=script&lang=ts&"
export * from "./FilmListItem.vue?vue&type=script&lang=ts&"
import style0 from "./FilmListItem.vue?vue&type=style&index=0&id=06d92eb3&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06d92eb3",
  null
  
)

export default component.exports